module.exports = __webpack_public_path__ + "static/media/web-card.c345189a.svg";